export enum VideoType {
  Moment = "Moment",
  Webinar = "Webinar",
  Trailer = "Trailer",
  Ad = "Ad"
}
